export default "__VITE_ASSET__FW4v71iG__"